import React, { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { extractApiError } from "../lib/errors";
import { toast } from "sonner";

const LOGO = "/ashra-logo.png";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(extractApiError(err, "Could not send reset email"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative min-h-screen bg-white text-zinc-900 overflow-hidden flex items-center justify-center px-4">
      <div className="absolute inset-0 pointer-events-none overflow-hidden">
        <div className="absolute -top-32 -left-32 h-[28rem] w-[28rem] rounded-full blur-3xl opacity-30 ashra-gradient-bg" />
        <div className="absolute -bottom-32 -right-32 h-[28rem] w-[28rem] rounded-full blur-3xl opacity-20 ashra-gradient-bg" />
      </div>
      <div className="relative w-full max-w-md bg-white border border-zinc-200 rounded-3xl shadow-2xl shadow-violet-500/5 p-8">
        <Link to="/" className="flex items-center gap-2 mb-6" data-testid="forgot-logo">
          <img src={LOGO} alt="Ashra AI" className="h-10 w-auto" />
        </Link>
        <h1 className="font-display text-2xl font-extrabold tracking-tight">Reset your password</h1>
        <p className="mt-1 text-sm text-zinc-600">Enter your email and we'll send a reset link.</p>

        {sent ? (
          <div className="mt-6 rounded-2xl bg-emerald-50 border border-emerald-200 text-emerald-800 px-4 py-3 text-sm" data-testid="forgot-sent">
            If <span className="font-semibold">{email}</span> is on file, a reset link is on its way. The link expires in 1 hour.
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input
              type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
              placeholder="you@creator.com"
              className="w-full rounded-xl border border-zinc-200 bg-white px-4 py-3 text-sm outline-none focus:border-violet-500"
              data-testid="forgot-email"
            />
            <button type="submit" disabled={loading} data-testid="forgot-submit"
              className="w-full rounded-xl ashra-gradient-bg text-white font-semibold py-3 text-sm hover:opacity-95 transition disabled:opacity-60">
              {loading ? "Sending…" : "Send reset link"}
            </button>
          </form>
        )}

        <p className="mt-6 text-sm text-zinc-500 text-center">
          Remembered it? <Link to="/login" className="text-violet-600 font-medium" data-testid="forgot-back-to-login">Back to login</Link>
        </p>
      </div>
    </div>
  );
}
